import K from '../constants';
import restHelpers from '../helpers/restHelper';

const getAllFn = () => restHelpers.withBearer.get(`${K.API_URL}/notices`, {});

const getPerImeiFn = imei => restHelpers.withBearer.get(`${K.API_URL}/notices/${imei}`, {});

const getCrashReportFn = plate => restHelpers.withBearer.get(`${K.API_URL}/crash-reports/${plate}`, {});

const getDetailPositionsFn = imei => restHelpers.withBearer.get(`${K.API_URL}/positions/${imei}`, {});

const confirmFn = id => restHelpers.withBearer.put(`${K.API_URL}/notices/${id}`, { data: { state: 'archived' } });

const discardFn = id => restHelpers.withBearer.put(`${K.API_URL}/notices/${id}`, { data: { state: 'cancelled' } });

const getOverRPMFuelTheftGeofenceFn = ({ size = 7, from } = {}) => restHelpers.withBearer.get(`${K.API_URL}/notifications/over-rpm-and-fuel-theft-and-geofence?_=${new Date().getTime()}&size=${size}${from ? `&from=${from}` : ''}`, {});

const getGeofencesFn = () => restHelpers.withBearer.get(`${K.API_URL}/notifications/geofences`, {});

const setReadManyFn = ({ plate, type }) => restHelpers.withBearer.put(`${K.API_URL}/notifications/read-many`, { data: { plate, type } });

export default {
  getAll: getAllFn,
  getPerImei: getPerImeiFn,
  getDetailPositions: getDetailPositionsFn,
  getCrashReport: getCrashReportFn,
  confirm: confirmFn,
  discard: discardFn,
  getOverRPMFuelTheftGeofence: getOverRPMFuelTheftGeofenceFn,
  getGeofences: getGeofencesFn,
  setReadMany: setReadManyFn
};



// WEBPACK FOOTER //
// ./src/services/notices.js